import { trpc } from "@/lib/trpc";
import { toast } from "sonner";

export const useSettingsMutation = (mode: "create" | "update" = "update", setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    
    const mutation = mode === "create" 
        ? trpc.settings.create.useMutation()
        : trpc.settings.update.useMutation();

    return {
        mutate: (data: any) => {
            mutation.mutate(data, {
                onSuccess: async () => {
                    // Force invalidate and refetch settings data
                    await utils.settings.findOne.invalidate();
                    await utils.settings.findOne.refetch();
                    toast.success("Settings updated successfully");
                    if(setLoading)  setLoading(false);
                },
                onError: (error: any) => {
                    if(setError)  setError(error.message || "An error occurred");
                    if(setLoading)  setLoading(false);
                },
            });
        },
        isLoading: mutation.isPending,
        error: mutation.error,
    };
};

export const useUpdateSettingsMutation = () => {
    const utils = trpc.useUtils();
    
    return trpc.settings.update.useMutation({
        onSuccess: async () => {
            // Force invalidate and refetch settings data
            await utils.settings.findOne.invalidate();
            await utils.settings.findOne.refetch();
        },
    });
};

export const useTestEmailMutation = (
    onSuccess?: (data: any) => void,
    onError?: (error: any) => void
) => {
    return trpc.settings.testEmail.useMutation({
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            } else {
                toast.error(error.message || "Failed to send test email");
            }
        },
    });
};
